export const demandPeriority: { [key: string]: string } = {
    URGENT: 'فوری',
    HIGH: 'بالا',
    MID: 'متوسط',
    LOW: 'پایین',
}
